import styled from 'styled-components';
import { IMG_GUIDE1, IMG_GUIDE2, IMG_GUIDE3, IMG_GUIDE4 } from '@repo/assets';
import { Button, Modal } from '@successmode-ktp/kui';
import CashPickupGuideContent from './CashPickupGuideContent';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const CashPickupGuideModal = ({ isOpen, onClose }: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      hasBackdrop
      wrapperStyle={{ maxWidth: '400px', width: '90%' }}
    >
      <CashPickupGuideContent textAlign='center' />
      <Button type='button' onClick={onClose}>
        Confirm
      </Button>
    </Modal>
  );
};

export default CashPickupGuideModal;

const TitleWrapper = styled.div`
  margin-bottom: 8px;
  text-align: center;
`;
const Title = styled.strong`
  display: block;
  margin-bottom: 4px;
  font-size: 22px;
  font-weight: 700;
  line-height: 150%;
`;

const SubTitle = styled.small`
  color: var(--KTP-Grayscale-Gray_07, #999);
  font-size: 14px;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
`;

const GuideWrapper = styled.ul`
  display: flex;
  margin-bottom: 16px;
  flex-direction: column;
  gap: 36px;
`;

const GuideImg = styled.img`
  width: 100%;
  margin-bottom: 8px;
`;

const GuideText = styled.li`
  color: #80848a;
  text-align: center;
  font-size: 14px;
  line-height: 150%; /* 21px */
  font-weight: 500;
  letter-spacing: -0.28px;
`;

const Link = styled.a`
  color: #80848a;
  text-decoration: underline;
`;
